import * as React from 'react'
import { Column } from '../types'
import SystemSettings from './system_settings'
import TextSettings from './text_settings'
import NumberSettings from './number_settings'
import SelectSettings from './select_settings'
import I18n from '../../../../libs/i18n'

interface ColumnTypeSettingsProps {
  column: Column
  onUpdate: (updates: Partial<Column>) => void
  generateOptionId: () => string
  system_column_keys: string[]
  required_eligible_system_keys: string[]
}

export default function ColumnTypeSettings({
  column,
  onUpdate,
  generateOptionId,
  system_column_keys,
  required_eligible_system_keys,
}: ColumnTypeSettingsProps) {
  const type = column.type

  if (type === 'Projects::Columns::System') {
    return (
      <SystemSettings
        column={column}
        onUpdate={onUpdate}
        system_column_keys={system_column_keys}
        required_eligible_system_keys={required_eligible_system_keys}
      />
    )
  }

  if (type === 'Projects::Columns::Text') {
    return <TextSettings column={column} onUpdate={onUpdate} />
  }

  if (type === 'Projects::Columns::Number') {
    return <NumberSettings column={column} onUpdate={onUpdate} />
  }

  if (type === 'Projects::Columns::Date') {
    return <span className="small text-muted">{I18n.t('project_groups.columns_editor.no_settings')}</span>
  }

  if (type === 'Projects::Columns::Select') {
    return (
      <SelectSettings
        column={column}
        onUpdate={onUpdate}
        generateOptionId={generateOptionId}
      />
    )
  }

  return null
}
